const initialState = {
    categories: [],
    products: [],
};

const bestSelling = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_BEST_SELLING':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default bestSelling;
